import { Service, ServiceContent } from '@/base-api/types';
import { OfferModalInner } from '@/components/offer-modal-inner';
import { useDialog } from '@/contexts/dialog-context';

interface UseOfferModalProps {
  cartId: string;
  variantId: number;
  serviceContent: ServiceContent;
  service: Service;
}

export const useOfferModal = ({
  cartId,
  variantId,
  serviceContent,
  service,
}: UseOfferModalProps) => {
  const { setOpen, setContent } = useDialog();

  const openOfferModal = () => {
    setContent(
      <OfferModalInner
        content={serviceContent.offer_modal}
        service={service}
        cartId={cartId}
        variantId={variantId}
        reloadOnAddOfferToCart={true}
      />,
    );
    setOpen(true);
  };

  return { openOfferModal };
};
